import gql from 'graphql-tag';

export const getOrderDetailsByIdQuery = (orderId: string, version: number) => gql`
  query {
    swap(orderId: "${orderId}", version: ${version}) {
      id
      tenantId
      groupId
      counterParty
      status
      tradeDate
      settlementDate
      maturityDate
      terminationDate
      timestamp
      clientId
      swapName
      swapId
      swapVersion
      swapAttributes
      message
      currentBasket {
          id
          basketId
          basketName
          version
          clientId
          status
          orderId
          tenantId
          createdByUser
          createdDate
          basketItemDetails {
              basketNotional
              basketItems {
                  id
                  basketItemId
                  version
                  fundId
                  security
                  securityName
                  bbgTickerExch
                  holdId
                  isin
                  sedol
                  quantity
                  substitutionQuantity
                  divRate
                  exDate
                  recordDate
                  price
                  newPrice
                  fxRate
                  tradeId
                  eligible
                  createdByUser
                  createdDate
                  inputCurrency
                  swapCurrency
                  notional
                  location
                  settlementDate
                  tradeDate
                  tradeSource
                  tradeType
                  tradeAction
                  originalBasketId
                  originalBasketItemId
                  originalHoldId
                  assetClass
                  securityIssueCountry
                  hedgedNotional
              }
          }
          rollupItemDetails {
              basketNotional
              isUnwind
              basketItems {
                  id
                  basketItemId
                  version
                  fundId
                  security
                  securityName
                  bbgTickerExch
                  holdId
                  isin
                  sedol
                  quantity
                  substitutionQuantity
                  divRate
                  exDate
                  recordDate
                  price
                  newPrice
                  fxRate
                  tradeId
                  eligible
                  createdByUser
                  createdDate
                  inputCurrency
                  swapCurrency
                  notional
                  location
                  settlementDate
                  tradeDate
                  tradeSource
                  tradeType
                  tradeDate
                  tradeAction
                  originalBasketId
                  originalBasketItemId
                  originalHoldId
                  assetClass
                  securityIssueCountry
                  hedgedNotional
              }
          }
          consolidatedItems{
           basketNotional
              isUnwind
              basketItems {
                  id
                  basketItemId
                  version
                  fundId
                  security
                  securityName
                  bbgTickerExch
                  holdId
                  isin
                  sedol
                  quantity
                  substitutionQuantity
                  divRate
                  exDate
                  recordDate
                  price
                  newPrice
                  fxRate
                  tradeId
                  eligible
                  createdByUser
                  createdDate
                  inputCurrency
                  swapCurrency
                  notional
                  location
                  settlementDate
                  tradeDate
                  tradeSource
                  tradeType
                  tradeDate
                  tradeAction
                  originalBasketId
                  originalBasketItemId
                  originalHoldId
                  assetClass
                  securityIssueCountry
              }
          }
      }
    }
  }
`;

export const getSecurityDetailsQuery = () => gql`
  query {
    getSecurities {
      ticker
      securityName
      cusip
      isin
      sedol
      issueCurrency
      bnySecurityId
    }
  }
`;

export const getBasketsbyDateRangeQuery = (
  orderId: string,
  swapCurrency: string,
  fromDate: string,
  toDate: string,
) => gql`
  query {
    baskets(orderId:"${orderId}",swapCurrency:"${swapCurrency}" ${!fromDate && !toDate ? '' : `,fromDate:"${fromDate}",toDate:"${toDate}"`}) {
      id
      basketId
      basketName
      version
      clientId
      status
      orderId
      tenantId
      createdByUser
      createdDate
      basketItemDetails {
        basketNotional
        basketItems {
          id
          basketItemId
          version
          security
          securityName
          bbgTickerExch
          isin
          sedol
          quantity
          substitutionQuantity
          divRate
          exDate
          recordDate
          price
          newPrice
          fxRate
          tradeId
          eligible
          createdByUser
          createdDate
          inputCurrency
          swapCurrency
          notional
          fundId
          location
          settlementDate
          tradeDate
          tradeSource
          tradeType
          tradeAction
          originalBasketId
          originalBasketItemId
        }
      }
      rollupItemDetails {
        basketNotional
        basketItems {
          id
          basketItemId
          version
          fundId
          security
          securityName
          bbgTickerExch
          isin
          sedol
          quantity
          substitutionQuantity
          divRate
          exDate
          recordDate
          price
          newPrice
          fxRate
          tradeId
          eligible
          createdByUser
          createdDate
          inputCurrency
          swapCurrency
          notional
          location
          settlementDate
          tradeDate
          tradeSource
          tradeType
          tradeDate
          tradeAction
          originalBasketId
          originalBasketItemId
        }
      }
    }
  }
`;
